import { Box, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom';
import { CheckAccessFunc } from '../../../../Components/CommonFunctions/CommonFunctions'
import CommonGridHeader, { CommonEditButton } from '../../../../Components/Common Components/CommonComponents'


export default function CheckerConfig() {
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Template Configuration", "SubTab")?.editAccess
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [approverList, setApproverList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [isloader, setisloader] = useState(false);

    useEffect(() => {
        getApproverData()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const getApproverData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.USER_ACCESS_APPROVER_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setApproverList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {

        approverList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'action_type', headerName: 'Type', flex: 0.25,
                renderCell: (params) => (params.row.action_type ? params.row.action_type?.length > 40 ?
                    <Tooltip placement="top" title={params.row.action_type}><Typography fontSize={'0.9vw'}>{params.row.action_type?.slice(0, 37) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.action_type}</Typography> : '-')
            },
            {
                field: 'discount_approver_count', headerName: 'No Of Users', flex: 0.25, align: 'center', headerAlign: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.discount_approver_count ? params?.row?.discount_approver_count : '0'}</Box>)
            },
            ...(commonDisable ? [
                {
                    field: 'action', headerName: 'Action', flex: 0.25, align: 'center', headerAlign: 'center',
                    renderCell: (params) => (
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                <CommonEditButton size="1.5vw" onClick={() => { history.push("/Settings/UserConfig/AddApprover") }} />
                            </Stack>
                        </Stack>)
                }
            ] : [])
        ]
        return (
            <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
                <DataGrid
                    rows={approverList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: CommonGridHeader.CommonToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}